// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mQIC","image":"Header_image__QC026","name":"Header_name__2VN9x","info":"Header_info__EbGX7","infoRow":"Header_infoRow__2OvR3"};